import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row gx-xxl-6" }
const _hoisted_2 = { class: "col-lg-4" }
const _hoisted_3 = { class: "form-group mb-25" }
const _hoisted_4 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_5 = ["placeholder", "value"]
const _hoisted_6 = { class: "col-lg-4" }
const _hoisted_7 = { class: "form-group mb-25" }
const _hoisted_8 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_9 = ["value", "disabled"]
const _hoisted_10 = { value: null }
const _hoisted_11 = ["value"]
const _hoisted_12 = {
  key: 0,
  class: "text-muted d-block mt-2"
}
const _hoisted_13 = { class: "col-lg-4" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "col-12" }
const _hoisted_18 = { class: "form-group position-relative" }
const _hoisted_19 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_20 = { class: "adjustment-search-box position-relative w-100" }
const _hoisted_21 = ["placeholder"]
const _hoisted_22 = {
  key: 0,
  class: "search-results-dropdown mt-2"
}
const _hoisted_23 = { class: "result-list-header" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "result-main" }
const _hoisted_26 = { class: "result-name" }
const _hoisted_27 = { class: "result-meta" }
const _hoisted_28 = { class: "result-side" }
const _hoisted_29 = { class: "result-code" }
const _hoisted_30 = {
  key: 0,
  class: "result-empty-state"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", {
    action: "#",
    class: "mb-40",
    onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addFirstResult && _ctx.addFirstResult(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, [
            _createTextVNode(_toDisplayString(_ctx.t("adjustment_page.reference_no")) + " ", 1),
            _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
          ]),
          _createElementVNode("input", {
            type: "text",
            class: "w-100 h-55 border-0 rounded-1 fs-14 text-black bg-white px-3 shadow-sm",
            placeholder: _ctx.t('adjustment_page.reference_no'),
            value: _ctx.referenceNo,
            readonly: ""
          }, null, 8, _hoisted_5)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("label", _hoisted_8, [
            _createTextVNode(_toDisplayString(_ctx.t("adjustment_page.warehouse")) + " ", 1),
            _cache[7] || (_cache[7] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
          ]),
          _createElementVNode("select", {
            class: "bg-white border-0 rounded-1 fs-14 text-optional w-100 h-55",
            value: _ctx.warehouseId,
            disabled: _ctx.warehouseLocked || _ctx.isLoading,
            onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:warehouseId', ($event.target as HTMLSelectElement).value ? Number(($event.target as HTMLSelectElement).value) : null)))
          }, [
            _createElementVNode("option", _hoisted_10, _toDisplayString(_ctx.t("adjustment_page.select_warehouse")), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.warehouses, (w) => {
              return (_openBlock(), _createElementBlock("option", {
                key: w.id,
                value: w.id
              }, _toDisplayString(w.name), 9, _hoisted_11))
            }), 128))
          ], 40, _hoisted_9),
          (_ctx.warehouseLocked)
            ? (_openBlock(), _createElementBlock("small", _hoisted_12, _toDisplayString(_ctx.t("adjustment_page.warehouse_locked_from_profile")), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.t("adjustment_page.adjustment_date")), 1),
          _createElementVNode("input", {
            type: "date",
            class: "w-100 h-55 border-0 rounded-1 fs-14 text-black bg-white px-3 shadow-sm",
            value: _ctx.adjustmentDate,
            readonly: ""
          }, null, 8, _hoisted_16)
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.t("adjustment_page.choose_product")), 1),
          _createElementVNode("div", _hoisted_20, [
            _withDirectives(_createElementVNode("input", {
              ref: "searchInput",
              type: "text",
              placeholder: _ctx.t('adjustment_page.scan_search_product'),
              class: "adjustment-search-input",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchQuery) = $event)),
              onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('search-product', _ctx.searchQuery))),
              onFocus: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isFocused = true)),
              onKeyup: _cache[4] || (_cache[4] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.addFirstResult && _ctx.addFirstResult(...args)), ["prevent"]), ["enter"])),
              autocomplete: "off"
            }, null, 40, _hoisted_21), [
              [_vModelText, _ctx.searchQuery]
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("span", {
              class: "search-icon",
              "aria-hidden": "true"
            }, [
              _createElementVNode("i", { class: "ri-search-line" })
            ], -1))
          ]),
          (_ctx.shouldShowResults)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.normalizedQuery.length ? _ctx.t("adjustment_page.matching_products") : _ctx.t("adjustment_page.available_products")), 1),
                  _createElementVNode("small", null, _toDisplayString(_ctx.t("adjustment_page.items_count", { count: _ctx.searchResults.length })), 1)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResults, (product) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: product.id,
                    type: "button",
                    class: "result-item",
                    onClick: ($event: any) => (_ctx.selectProduct(product))
                  }, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("strong", _hoisted_26, _toDisplayString(product.name), 1),
                      _createElementVNode("small", _hoisted_27, [
                        _createTextVNode(_toDisplayString(product.category?.name || _ctx.t("adjustment_page.no_category")) + " ", 1),
                        _cache[9] || (_cache[9] = _createElementVNode("span", { class: "meta-dot" }, "•", -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.warehouseName), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("span", _hoisted_29, _toDisplayString(product.code), 1),
                      _createElementVNode("span", {
                        class: _normalizeClass(["result-stock", { 'is-low': _ctx.getAvailableStock(product) <= 0 }])
                      }, _toDisplayString(_ctx.t("adjustment_page.stock")) + ": " + _toDisplayString(_ctx.getAvailableStock(product)), 3)
                    ])
                  ], 8, _hoisted_24))
                }), 128)),
                (_ctx.searchResults.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_ctx.t("adjustment_page.no_products_for_selected_warehouse")), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 32))
}